import React from "react";

import "./stylesDashboardPieChart.css";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { color } from "chart.js/helpers";
import RebetLoader from "../../RebetLoader/RebetLoader";

function DashboardPieChart({ title, pieData, isApiRunning = false }) {
  ChartJS.register(ArcElement, Tooltip, Legend);

  const labels = pieData.map((item) => item.device);
  const data = pieData.map((item) => item.count);
  const colors = pieData.map((item) => item.color);

  const graphData = {
    labels,
    datasets: [
      {
        label: false,
        data,
        backgroundColor: colors,
        borderColor: colors,
        borderWidth: 1,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false,
        labels: {
          boxWidth: 20,
          padding: 20,
        },
      },
      datalabels: {
        anchor: "center",
        align: "center",
        formatter: (value, context) => {
          const dataset = context.chart.data.datasets[0];
          const total = dataset.data.reduce((acc, val) => acc + val, 0);
          const percentage = ((value / total) * 100).toFixed(0) + "%";
          return [`${value.toLocaleString()}`, `(${percentage})`];
        },
        color: "black",
        font: {
          family: "Poppins-regular",
          weight: "bold",
          size: 14,
        },
      },
      tooltip: {
        enabled: true,
        mode: "nearest",
        intersect: false,
        backgroundColor: "#25252F",
        titleFont: {
          family: "Poppins-regular",
          size: 16,
          weight: "bold",
        },
        bodyFont: {
          family: "Poppins-regular",
          size: 14,
        },
        padding: 15,
        displayColors: true,
      },
    },
  };

  return (
    <div className="dashboard-pie-chart">
      <h2>{title}</h2>
      {isApiRunning ? (
        <RebetLoader height={"100px"} width={"100px"} />
      ) : (
        <>
          <Pie data={graphData} options={options} />
          <div className="legend-container">
            {labels.map((label, index) => (
              <div key={index} className="legend-item">
                <div
                  className="legend-color"
                  style={{
                    backgroundColor:
                      graphData.datasets[0].backgroundColor[index],
                  }}
                ></div>
                <div className="legend-label">{label}</div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default DashboardPieChart;
